import heic2any from "heic2any";

const VALID_IMAGES_MIME_TYPES = [
    "image/webp",
    "image/jpeg",
    "image/png",
    "image/heic",
    "image/heif",
];

const VALID_VIDEOS_MIME_TYPES = [
    "video/mp4",
    "video/webm",
    "video/ogg",
    "video/avi",
    "video/quicktime",
    "video/x-m4v",
    "video/3gpp",
    "video/mpeg",
];

export function bytesToMB(bytes: number) {
    return bytes / (1024 * 1024);
}

export function isUploadedFileVideo(file: File | undefined) {
    return file?.type ? VALID_VIDEOS_MIME_TYPES.includes(file.type) : false;
}

export const INVALID_IMAGE_MSG = "Dieses Datei-Format wird nicht unterstützt.";
export const EXCESS_IMAGE_LIMIT_MSG =
    "Es können maximal 20 Bilder hochgeladen werden.";

export const isValidImage = (blob: Blob) => {
    return VALID_IMAGES_MIME_TYPES.includes(blob.type);
};

export const isValidVideo = (blob: Blob) => {
    return VALID_VIDEOS_MIME_TYPES.includes(blob.type);
};

export function isHeic(file: File | Blob): boolean {
    return file.type === "image/heic" || file.type === "image/heif";
}

export async function heicToWebp(file: File): Promise<File> {
    const convertedFile = await heic2any({
        blob: file,
        toType: "image/webp",
    });
    const blob = Array.isArray(convertedFile)
        ? convertedFile[0]
        : convertedFile;
    return new File([blob], file.name.replace(/\..+$/, ".webp"), {
        type: "image/webp",
    });
}
